import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface ThemeCustomProviderProps {
    children: ReactNode;
}

const ThemeContext = createContext<string | undefined>(undefined);

export const ThemeCustomProvider: React.FC<ThemeCustomProviderProps> = ({ children }) => {
    const location = useLocation();
    const [theme, setTheme] = useState('themeEq'); // Default theme

    useEffect(() => {
        const isImmo = location.search.includes('ui=immobilier');
        if (isImmo) {
            setTheme('themeImmo');
            sessionStorage.setItem('EstImmo', String(isImmo));
        } else {
            setTheme('themeEq');
        }
    }, [location]);

    return (
        <ThemeContext.Provider value={theme}>
            {children}
        </ThemeContext.Provider>
    );
};
export const useCustomTheme = () => useContext(ThemeContext);

 